module.exports = "<div class=\"snackbar-text md-body-1\" ng-transclude=content> </div> <div class=snackbar-action ng-if=$ctrl.enabledAction> <md-button class=md-accent> <span ng-transclude=action></span> </md-button> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/snackbar/snackbar.html
 ** module id = 454
 ** module chunks = 0
 **/